module.exports = __webpack_public_path__ + "7db7f4ab7ebbc4c1b921e9bdb571c5f5.gif";